import { create } from "zustand";

interface ModalState {
  isInviteAgentModalOpen: boolean;
  wasInviteSent: boolean;
  openInviteAgentModal: () => void;
  closeInviteAgentModal: () => void;
  setWasInviteSent: (value: boolean) => void;
}

export const useInviteAgentModalStore = create<ModalState>((set) => ({
  isInviteAgentModalOpen: false,
  wasInviteSent: false,
  openInviteAgentModal: () => set({ isInviteAgentModalOpen: true, wasInviteSent: false }),
  closeInviteAgentModal: () => set({ isInviteAgentModalOpen: false }),
  setWasInviteSent: (value: boolean) => set({ wasInviteSent: value }),
}));
